// Immediately check for IDEAL code before DOM is fully loaded
(function() {
  // Get affiliate code from URL parameter or localStorage
  const urlParams = new URLSearchParams(window.location.search);
  const codeParam = urlParams.get('code');
  const storedCode = localStorage.getItem('affiliateCode');
  
  // Store code parameter immediately if present
  if (codeParam === 'IDEAL') {
    localStorage.setItem('affiliateCode', 'IDEAL');
  }
  
  // Apply critical styles immediately if affiliate code is IDEAL
  if (codeParam === 'IDEAL' || storedCode === 'IDEAL') {
    const criticalStyles = `
      /* Announcement Bar */
      .quotes-2.slick-slider,
      .custom-Announcement-bar.quotes-2.ideal-image.hhh,
      .custom-Announcement-bar-inner.slick-slide,
      .custom-Announcement-bar-inner.slick-cloned,
      .custom-Announcement-bar-inner.slick-active,
      .slick-track,
      .slick-list.draggable {
          background-color: #0B2341 !important;
          border-color: rgb(29, 29, 29) !important;
      }
      
      .custom-Announcement-bar-inner a,
      .custom-Announcement-bar-inner span {
          color: white !important;
          font-size: 13.7px !important;
          line-height: 13.7px !important;
          padding: 8px 30px !important;
      }

      /* Button styling */
      .btn--primary,
      .hero__btn.btn--neutral,
      .btn--soft,
      .product__submit__add,
      button[data-add-to-cart],
      .dynamic_primary_color {
          background-color: #0B2341 !important;
          color: white !important;
          border-color: #0B2341 !important;
      }
    `;
    
    // Create and append style tag to document head
    const styleElement = document.createElement('style');
    styleElement.textContent = criticalStyles;
    
    // Insert styles as early as possible
    if (document.head) {
      document.head.appendChild(styleElement);
    } else {
      // If head isn't available yet, use a different approach
      document.addEventListener('DOMContentLoaded', () => {
        document.head.appendChild(styleElement);
      });
    }
  }
})();

// Main functionality after DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
    // Get current URL and parameters
    const currentUrl = window.location.pathname;
    const currentParameters = window.location.search;
    const urlParams = new URLSearchParams(currentParameters);
    
    // Check for code parameter in URL and localStorage
    const codeParam = urlParams.get('code');
    const storedCode = localStorage.getItem('affiliateCode');
    
   // console.log('Code parameter:', codeParam);
   // console.log('Stored code:', storedCode);
    
    // Add direct CSS for customproducticon6 when code is not IDEAL
    if (codeParam !== 'IDEAL' && storedCode !== 'IDEAL') {
       // console.log('Non-IDEAL code detected - Adding custom CSS for customproducticon6');
        const hideCustomProductIcon = `
            li.hasMegaMenu.customtitle.customproducticon6 {
                display: none !important;
                visibility: hidden !important;
                width: 0 !important;
                height: 0 !important;
                position: absolute !important;
                overflow: hidden !important;
                opacity: 0 !important;
                pointer-events: none !important;
                clip: rect(0 0 0 0) !important;
                clip-path: inset(50%) !important;
                margin: -1px !important;
            }
        `;
        const styleSheet = document.createElement("style");
        styleSheet.innerText = hideCustomProductIcon;
        document.head.appendChild(styleSheet);
    }

    // Function to wait for elements to be available
    function waitForElements(selector, callback, maxAttempts = 10) {
        let attempts = 0;
        
        function checkElements() {
            const elements = document.querySelectorAll(selector);
            if (elements.length > 0) {
                callback(elements);
                return;
            }
            
            attempts++;
            if (attempts < maxAttempts) {
                setTimeout(checkElements, 500); // Try again in 500ms
            } else {
               // console.log(`Elements not found after ${maxAttempts} attempts:`, selector);
            }
        }
        
        checkElements();
    }

    // Modify the menu items after ensuring they exist
    function initializeMenuItems() {
        // Wait for menu items to be available
        waitForElements('.customspan', (customSpans) => {
           // console.log('Looking for menu items to hide...');
           // console.log('Found customspan elements:', customSpans.length);
            
            // Hide Skin Care Library items
            customSpans.forEach(span => {
                const text = span.textContent.trim();
               // console.log('Checking span text:', text);
                if (text === 'SKIN CARE LIBRARY') {
                    const menuItem = span.closest('li.hasMegaMenu');
                    if (menuItem) {
                        // MODIFIED: Conditional hiding/showing for SKIN CARE LIBRARY
                        if (localStorage.getItem('affiliateCode') === 'IDEAL') {
                           // console.log('Hiding SKIN CARE LIBRARY menu item for IDEAL');
                            menuItem.classList.add('hidden');
                            menuItem.style.display = 'none';
                        } else {
                           // console.log('Ensuring SKIN CARE LIBRARY menu item is visible for non-IDEAL');
                            menuItem.classList.remove('hidden');
                            menuItem.style.removeProperty('display');
                        }
                    }
                }
            });
        });
        
        // Wait for placeholder items to be available
        waitForElements('li.hasMegaMenu.customtitle a.menu-link', (placeholderSpans) => {
           // console.log('Found placeholder menu items:', placeholderSpans.length);
            
            placeholderSpans.forEach(span => {
                // Check for any menu item containing "SALE"
                if (span.textContent.trim().toUpperCase().includes("SALE")) {
                    const menuItem = span.closest('li.hasMegaMenu');
                    if (menuItem && localStorage.getItem('affiliateCode') === 'IDEAL') {
                        // Hide SALE menu for IDEAL
                        menuItem.style.display = 'none !important';
                        menuItem.classList.add('hidden');
                        menuItem.setAttribute('aria-hidden', 'true');
                        menuItem.style.visibility = 'hidden';
                        menuItem.style.position = 'absolute';
                        menuItem.style.width = '0';
                        menuItem.style.height = '0';
                        menuItem.style.overflow = 'hidden';
                        menuItem.style.pointerEvents = 'none';
                    }
                }
                
                // Existing placeholder check
                if (span.textContent.trim() === '-') {
                    const menuItem = span.closest('li.hasMegaMenu');
                    if (menuItem) {
                        if (localStorage.getItem('affiliateCode') === 'IDEAL') {
                            // Show and update for IDEAL
                            span.textContent = 'TREATMENTS';
                            span.href = 'https://idealimage.com?ref=Skintypesolutions';
                            span.target = '_blank';
                            span.rel = 'noopener';
                            menuItem.style.removeProperty('display');
                            menuItem.classList.remove('hidden');
                        } else {
                            // Hide menu item for non-IDEAL
                            menuItem.style.display = 'none !important';
                            menuItem.classList.add('hidden');
                            menuItem.setAttribute('aria-hidden', 'true');
                            menuItem.style.visibility = 'hidden';
                            menuItem.style.position = 'absolute';
                            menuItem.style.width = '0';
                            menuItem.style.height = '0';
                            menuItem.style.overflow = 'hidden';
                            menuItem.style.pointerEvents = 'none';
                            
                            // Also hide the link itself
                            span.style.cssText = `
                                display: none !important;
                                visibility: hidden !important;
                                pointer-events: none !important;
                            `;
                        }
                    }
                }

                // Check for HOME button and update link if code is IDEAL
                if (span.textContent.trim().toUpperCase() === 'HOME') {
                    if (localStorage.getItem('affiliateCode') === 'IDEAL') {
                       // console.log('Updating HOME button link for IDEAL code to /pages/ideal-image');
                        span.href = '/pages/ideal-image';
                    }
                }
            });
        });
        
        // Wait for mobile menu items to be available
        waitForElements('.accordion-title-custom-mb', (mobileAccordionTitles) => {
           // console.log('Found mobile accordion titles:', mobileAccordionTitles.length);
            
            mobileAccordionTitles.forEach(title => {
                const text = title.textContent.trim();
                // Add SALE check for mobile menu
                if (text.toUpperCase().includes("SALE") && localStorage.getItem('affiliateCode') === 'IDEAL') {
                    const accordionItem = title.closest('.accordion-item-custom-mb');
                    if (accordionItem) {
                        accordionItem.style.display = 'none !important';
                        accordionItem.classList.add('hidden');
                        accordionItem.setAttribute('aria-hidden', 'true');
                        accordionItem.style.visibility = 'hidden';
                        accordionItem.style.position = 'absolute';
                        accordionItem.style.width = '0';
                        accordionItem.style.height = '0';
                        accordionItem.style.overflow = 'hidden';
                        accordionItem.style.pointerEvents = 'none';
                    }
                }
                // Existing checks
                if (text === 'SKIN CARE LIBRARY' || text === '-') {
                    const accordionItem = title.closest('.accordion-item-custom-mb');
                    if (accordionItem) {
                        if (text === '-' && localStorage.getItem('affiliateCode') === 'IDEAL') {
                            // Show and update for IDEAL
                            title.textContent = 'TREATMENTS';
                            const link = accordionItem.querySelector('a') || document.createElement('a');
                            link.href = 'https://idealimage.com?ref=Skintypesolutions';
                            link.target = '_blank';
                            link.rel = 'noopener';
                            if (!accordionItem.contains(link)) {
                                accordionItem.appendChild(link);
                            }
                            accordionItem.style.removeProperty('display');
                            accordionItem.classList.remove('hidden');
                        } else {
                            // Hide for non-IDEAL or Skin Care Library (This needs to be conditional too for SCL)
                             if (text === 'SKIN CARE LIBRARY' && localStorage.getItem('affiliateCode') !== 'IDEAL') {
                                // Ensure SCL is visible for non-IDEAL in mobile
                                accordionItem.style.removeProperty('display');
                                accordionItem.classList.remove('hidden');
                            } else { // Covers SCL for IDEAL, and '-' for non-IDEAL
                                accordionItem.style.display = 'none';
                                accordionItem.classList.add('hidden');
                            }
                        }
                    }
                }

                // Check for HOME button in mobile menu and update link if code is IDEAL
                if (text.toUpperCase() === 'HOME' && localStorage.getItem('affiliateCode') === 'IDEAL') {
                    const accordionItem = title.closest('.accordion-item-custom-mb');
                    if (accordionItem) {
                        const link = accordionItem.querySelector('a.custom-main-links-ur');
                        if (link) {
                           // console.log('Updating mobile HOME button link for IDEAL code to /pages/ideal-image');
                            link.href = '/pages/ideal-image';
                        }
                    }
                }
            });
        });
    }

    // Call the initialization function when the DOM is ready (MOVED AND ALWAYS RUN)
    initializeMenuItems();

    // Also set up a mutation observer to handle dynamic updates (MOVED AND ALWAYS RUN)
    const menuObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            if (mutation.addedNodes.length) {
                initializeMenuItems();
            }
        }
    });

    menuObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
    
    // Proceed if either code parameter is IDEAL or stored code is IDEAL (for IDEAL-specific actions)
    if (codeParam === 'IDEAL' || storedCode === 'IDEAL') {
       // console.log('IDEAL code detected (URL or localStorage)');
        
        // Add redirect for /pages/sale
        if (currentUrl === '/pages/sale') {
           // console.log('Redirecting from sale page to ideal-image page...');
            window.location.href = '/pages/ideal-image';
            return;
        }
        
        // Add IDEAL-specific styles
        const idealStyles = `
            .btn--primary,
            .hero__btn.btn--neutral,
            .btn--soft {
                background-color: #0B2341 !important; /* Ideal Image navy blue */
                color: white !important;
                border-color: #0B2341 !important;
            }
            .btn--primary:hover,
            .hero__btn.btn--neutral:hover,
            .btn--soft:hover {
                background-color: #394761 !important; /* Darker navy */
                border-color: #394761 !important;
            }
            
            /* Add gold accent for special buttons/elements */
            .btn--special {
                background-color: #C4A052 !important; /* Ideal Image gold */
                color: white !important;
                border-color: #C4A052 !important;
            }
            .btn--special:hover {
                background-color: #B08F3E !important; /* Darker gold */
                border-color: #B08F3E !important;
            }
            
            /* Ensure customproducticon6 is visible for IDEAL users */
            li.hasMegaMenu.customtitle.customproducticon6 {
                display: block !important;
                visibility: visible !important;
            }
        `;
        
        const styleSheet = document.createElement("style");
        styleSheet.innerText = idealStyles;
        document.head.appendChild(styleSheet);
        
        // Redirect to ideal-image page if we're on homepage and have IDEAL code (from either source)
        if (currentUrl === '/' && !currentUrl.includes('/pages/ideal-image') && (codeParam === 'IDEAL' || storedCode === 'IDEAL')) {
           // console.log('Redirecting to ideal-image page...');
            // Preserve other URL parameters if they exist
            const newParams = new URLSearchParams(currentParameters);
            newParams.delete('code'); // Remove code parameter
            const paramString = newParams.toString();
            
            // Construct new URL
            let newUrl = '/pages/ideal-image';
            if (paramString) {
                newUrl += '?' + paramString;
            }
            
            // Redirect after a short delay
            setTimeout(function() {
                window.location.href = newUrl;
            }, 1000);
        }
    }
});

// Function to apply styles immediately
function applyIdealStyles() {
    // Critical styles that need to be applied immediately
    const criticalStyles = `
        /* Announcement Bar */
        .quotes-2.slick-slider,
        .custom-Announcement-bar.quotes-2.ideal-image.hhh,
        .custom-Announcement-bar-inner.slick-slide,
        .custom-Announcement-bar-inner.slick-cloned,
        .custom-Announcement-bar-inner.slick-active,
        .slick-track,
        .slick-list.draggable {
            background-color: #0B2341 !important;
            border-color: rgb(29, 29, 29) !important;
        }
        
        .custom-Announcement-bar-inner a,
        .custom-Announcement-bar-inner span {
            color: white !important;
            font-size: 13.7px !important;
            line-height: 13.7px !important;
            padding: 8px 30px !important;
        }

        /* Pre-footer only */
        .pre-footer-icons,
        #shopify-section-sections--23664209559854__pre_footer_icons_hhwwFM {
            display: none !important;
            visibility: hidden !important;
            height: 0 !important;
            overflow: hidden !important;
            padding: 0 !important;
            margin: 0 !important;
        }

        /* Product page elements */
        .product__submit_buttons,
        .dynamic_primary_color.product__submit_add,
        .product_submit_add,
        .product__submit__add,
        button[data-add-to-cart] {
            background-color: #0B2341 !important;
            color: #ffffff !important;
            border-color: #0B2341 !important;
        }

        /* Radio buttons and form elements */
        .radio_button input:checked + label,
        .radio__button input:checked + label {
            border-color: #0B2341 !important;
            background: #0B2341 !important;
            color: white !important;
        }

        .radio_inputs .radio_button,
        .radio__inputs .radio__button {
            border-color: #0B2341 !important;
        }

        .radio__button input:checked + label:hover,
        .radio_button input:checked + label:hover {
            background: #394761 !important;
            border-color: #394761 !important;
        }

        /* Radio button focus states */
        .radio__button input:focus + label,
        .radio_button input:focus + label {
            box-shadow: 0 0 0 2px rgba(74, 91, 123, 0.3) !important;
        }

        /* Radio legend color */
        .radio__legend__label,
        .radio__legend__value {
            color: #0B2341 !important;
        }

        .btn-text {
            color: #ffffff !important;
        }

        .btn-bg {
            background: #0B2341 !important;
        }
        
        /* Button styling */
        .btn--primary,
        .hero__btn.btn--neutral,
        .btn--soft {
            background-color: #0B2341 !important; /* Ideal Image navy blue */
            color: white !important;
            border-color: #0B2341 !important;
        }
        .btn--primary:hover,
        .hero__btn.btn--neutral:hover,
        .btn--soft:hover {
            background-color: #394761 !important; /* Darker navy */
            border-color: #394761 !important;
        }
        
        /* Gold accent for special buttons/elements */
        .btn--special {
            background-color: #C4A052 !important; /* Ideal Image gold */
            color: white !important;
            border-color: #C4A052 !important;
        }
        .btn--special:hover {
            background-color: #B08F3E !important; /* Darker gold */
            border-color: #B08F3E !important;
        }
        
        /* Ensure dynamic elements get styled */
        .dynamic_primary_color {
            background-color: #0B2341 !important;
            color: white !important;
            border-color: #0B2341 !important;
        }
    `;
    
    // Create and inject style element immediately in the head
    const styleElement = document.createElement('style');
    styleElement.textContent = criticalStyles;
    
    // Add the style to head with high priority
    if (document.head) {
        document.head.appendChild(styleElement);
    } else {
        // If head isn't available yet (unlikely but possible)
        document.addEventListener('DOMContentLoaded', () => {
            document.head.appendChild(styleElement);
        });
    }
    
    // Also inject into body as a fallback
    if (document.body) {
        document.body.insertAdjacentElement('afterbegin', styleElement.cloneNode(true));
    }
}

// Add jQuery extension for :contains case-insensitive selector if needed
jQuery.expr[':'].contains = function(a, i, m) {
    return jQuery(a).text().toUpperCase()
        .indexOf(m[3].toUpperCase()) >= 0;
};